import { injectGlobal } from 'styled-components';

export const hideCaptchaBadge = () => {
  injectGlobal`
        .grecaptcha-badge { visibility: hidden;}
    `;
};

/**
 * @deprecated - either use colours from the style-guide (Helpers package) or use the color prop on components
 */
export const theme = {
  brandFont: 'Gordita, Arial, sans-serif',
  colors: {
    white: '#ffffff',
    black: '#000000',
    red: '#ec0000',
    orange: '#ff8228',
    errorRed: '#ec0000',
    errorBackground: '#fdeaea',
    errorBorder: '#fbd6d6',
    errorText: '#710000',
    errorIcon: '#ff373c',
    redLight: '#f9adad',
    redDark: '#b30000',
    redDarker: '#c10c1a',
    redOutline: '#fbc2c2',
    blue: '#d2f0ff',
    grey700: '#737373',
    grey550: '#535353',
    grey500: '#505050',
    grey400: '#232323',
    grey300: '#2a2a2a',
    grey350: '#dcdcdc',
    grey200: '#aaaaaa',
    grey100: '#e3e3e3',
    grey75: '#f1f1f1',
    grey50: '#f4b435',
  },
};
